<template lang="pug">
  .flow-builder-action-show-products-template
    template-tools(v-if="!disabled", @delete="$emit('delete')")
    .template-platforms-container.badges.mb-3(v-if="disabled")
      b-badge(v-for="(platform) in selectedPlatformsObjects.slice(0, sliceEnd)", :key="platform.platform_id", :style="{'background-color': platformColor(platform.name, 0.7)}") {{ platform.title }}
      b-badge(v-if="selectedPlatformsObjects.slice(sliceEnd).length", variant="soft-secondary") {{ selectedPlatformsObjects.slice(sliceEnd).length }} más
    .template-platforms-container.overflow-x.no-wrap.mb-3(v-else)
      b-form-group
        label.text-help.text-sm Plataformas donde se usará este template:
        k-select.disabled-white.flush(placeholder="- Agregar plataformas -", :options="parsedPlatforms", :disabled="disabled", :value="selected_platforms", @input="updatePlatforms", multiple, :limit="3", :searchable="false")
    b-card.mb-0.no-shadow.w-100.bg-light-white
      .bg-white.mb-3
        p.mb-0 Cambiar estado de chatbot
        p.text-secondary.text-sm Activa o desactiva las respuestas automáticas del chatbot únicamente en la conversación donde se usa el template (por usuario y plataforma).
        fieldset.mb-3(:disabled="disabled")
          b-form-checkbox.mb-3(
            switch,
            v-if="template_attribute.name === 'status'",
            v-for="template_attribute in Template_Attributes",
            :key="template_attribute.template_attribute_id",
            :checked="parseBoolean(template_attribute.value)",
            @change="updateTemplateAttribute(template_attribute, $event)"
          ) {{ parseBoolean(template_attribute.value) ? 'Activar' : 'Desactivar' }} estatus de chatbot
</template>

<script>
import templateCommon from '../../helpers/template-common'
import TemplateTools from './common/Tools.vue'
import _debounce from 'lodash.debounce'

export default {
  mixins: [templateCommon],
  components: { TemplateTools, },
  mounted () {
    this.$root.$on('bv::collapse::state', (collapseId) => {
      if (collapseId === `advance_search_collapse_${this.template_id}`) {
        setTimeout(() => {
          this.repaintBlock()
        }, 500)
      }
    })
  },
  created () {
    this.updateTemplateAttribute = _debounce((template_attribute, value) => {
      let attribute = JSON.parse(JSON.stringify(template_attribute))
      attribute.value = value

      this.updateAttribute(this.block_id, this.template_id, attribute).then(() => {
        this.$message.success('Actualizado')
      })
    }, 100, { leading: false, trailing: true })
  }
}
</script>

<style lang="scss" scoped>
  .jumping-dots {
    margin: 15px auto;
    text-align:center;
  }

  .dot {
    display:inline-block;
    width:12px;
    height:12px;
    border-radius:50%;
    margin-right:3px;
    background: var(--gray-dark);
    animation: jump 1.3s ease infinite;
  }

  .dot:nth-child(2) {
    animation-delay: -1.1s;
  }

  .dot:nth-child(3) {
    animation-delay: -0.9s;
  }


  @keyframes jump {
    0%, 60%, 100% {
      transform: initial;
    }

    30% {
      transform: translateY(-15px);
    }
  }
</style>
